import { call, put, takeEvery } from 'redux-saga/effects';
import { LOAD_BALANCE_TIME_SERIES_LONG_TERM,
	RECEIVE_BALANCE_TIME_SERIES_LONG_TERM } from '../actions/timeSeriesLongTerm';
import { API_PATH } from '../utilities/apiPath'

function* fetchBalanceTimeSeriesLongTerm(action) {
  const token = action.token

  if (token) {
	  const endpoint = API_PATH + 'api/balancetimeseriesforuser/longterm';
	  const options = {
		  headers: {
		    Authorization: `Bearer ${token}`
		  }

	  }
	  const response = yield call(fetch, endpoint, options);
	  const data = yield response.json();
	  yield put({ type: RECEIVE_BALANCE_TIME_SERIES_LONG_TERM, timeseries: data });
	}
}

export function* loadBalanceTimeSeriesLongTerm() {
  yield takeEvery(LOAD_BALANCE_TIME_SERIES_LONG_TERM, fetchBalanceTimeSeriesLongTerm);
}